import React from "react";

const LastPageDoubleArrowIcon = (props) => (
  <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" {...props}>
    <path
      fill="currentColor"
      d="M6.41 6 5 7.41 9.58 12 5 16.59 6.41 18l6-6zm7 0L12 7.41 16.58 12 12 16.59 13.41 18l6-6z"
    />
  </svg>
);

export default LastPageDoubleArrowIcon;
